<template>
  <v-row dense class="px-3">
    <v-col cols="12" class="text-center">
      <div class="title">{{division.name}}</div>
    </v-col>
    <v-col cols="12" v-for="tab in divisionTabs" :key="tab.to">
      <v-btn
        block rounded
        color="color3 color3Text--text"
        large class="pa-9"
        :to="tab.to">
        {{tab.text}}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['division'],
  computed: {
    ...mapGetters(['tournament', 'view']),
    isTournament () {
      return this.tournament.isTournament && this.division.isTournament
    },
    isLeague () {
      return this.tournament.isLeague
    },
    isCoaches () {
      return this.division && this.division.isCoaches
    },
    divisionTabs () {
      const tabs = []

      if (this.division.regOpen) {
        tabs.push(
          {
            text: 'Register Now',
            to: `/tournament/${this.tournament.id}?tab=register`,
            count: this.division.teamCount
          }
        )
      }

      tabs.push(
        {
          text: `View The ${this.division.teamLabel}`,
          to: `/tournament/${this.tournament.id}/division/${this.division.id}/teams`,
          count: this.division.teamCount
        }
      )
      if (this.division.waitlistTeams.length && !this.isCoaches && (this.view.admin || this.division.showTeams) && !(this.view.public && this.division.hideWaitlist)) {
        tabs.push(
          {
            text: 'View The Waitlist',
            to: `/tournament/${this.tournament.id}/division/${this.division.id}/waitlist`,
            count: this.division.waitlistTeams.length
          }
        )
      }
      if ((this.isTournament || this.isLeague) && !this.isCoaches) {
        const stand = this.division.standings
        stand && stand.filter(f => (this.view.admin) || (this.view.public && f.published)).forEach((day, i) => {
          tabs.push({
            text: `Jump to the ${day.title}`,
            to: `/tournament/${this.tournament.id}/division/${this.division.id}/standings/${i}`,
            icon: day.locked ? 'fas fa-lock' : null
          })
        })
        if (this.isTournament) {
          this.division.days.filter(f => (this.view.admin) || (this.view.public && f.published)).forEach(day => {
            if (day.poolPlay) {
              const poolId = day.flight && day.flight.pools && day.flight.pools.length === 1 && day.flight.pools[0].id
              const addOn = poolId ? `/${poolId}` : ''
              tabs.push({
                text: `Jump to the ${day.name}`,
                to: `/tournament/${this.tournament.id}/division/${this.division.id}/round/${day.id}/pools${addOn}`,
                count: day.pools.length,
                icon: day.locked ? 'fas fa-lock' : null
              })
            } else {
              tabs.push({
                text: `Jump to the ${day.name}`,
                to: `/tournament/${this.tournament.id}/division/${this.division.id}/round/${day.id}/brackets`,
                icon: day.locked ? 'fas fa-lock' : null
              })
            }
          })
        }
        if (this.isLeague) {
          tabs.push({
            text: 'Jump to Regular Season',
            to: `/league/${this.tournament.id}/division/${this.division.id}/regular_season`
          })
          this.division.days.filter(f => (this.view.admin) || (this.view.public && f.published)).forEach(day => {
            if (!day.poolPlay) {
              tabs.push({
                text: `Jump to the ${day.name}`,
                to: `/league/${this.tournament.id}/division/${this.division.id}/round/${day.id}/brackets`,
                icon: day.locked ? 'fas fa-lock' : null
              })
            }
          })
        }
      }
      return tabs
    }
  }
}
</script>
